export const orderColumnValues = {
    productionPlanId : 'production_plan_id',
    year: 'year',
    planningSsnCd: 'planning_ssn_cd',
    planningSsn: 'planning_ssn',
    tgtSsnCd: 'tgt_ssn_cd',
    tgtSsn: 'tgt_ssn',
    bizCd: 'biz_cd',
    biz: 'biz',
    planningRegionCode: 'planning_region_code',
    planningRegionName: 'planning_region_name',
    channelCode: 'channel_code',
    channelName: 'channel_name',
    department: 'department',
    deptCd: 'dept_cd',
    Cls1_cd: 'cls1_cd',
    Cls2_cd: 'cls2_cd',
    gDept: 'g_dept',
    subCategory1: 'sub_category1',
    coreCategory: 'core_category',
    subCategory2: 'sub_category2',
    subCategory3: 'sub_category3',
    productionCategoryFabric: 'production_category_fabric',
    productionCategoryFabricProcessing: 'production_category_fabric_processing',
    productionCategorySewing: 'production_category_sewing',
    productionCategorySewingProcessing: 'production_category_sewing_Processing',
    planningSumCode: 'planning_sum_code',
    planningSum: 'planning_sum',
    localNameGhq: 'local_name_ghq',
    itemCd: 'item_cd',
    item: 'item',
    origPrice: 'orig_price',
    mainSampleCode: 'main_sample_code',
    frFabricCode: 'fr_fabric_code',
    frFabric: 'fr_fabric',
    supplierRawMaterialCode: 'supplier_raw_material_code',
    supplierRawMaterial: 'supplier_raw_material',
    rawMaterialSupplierCode: 'raw_material_supplier_code',
    rawMaterialSupplier: 'raw_material_supplier',
    vendorCoode: 'vendor_code',
    vendor: 'vendor',
    sewingFactoryCode: 'sewing_factory_code',
    sewingFactory: 'sewing_factory',
    branchFactoryCode: 'branch_factory_code',
    branchFactory: 'branchFactory',
    coeff: 'coeff',
    itemBranchNumber: 'item_branch_number',
    officialPlanStdQty: 'official_plan_std_qty',
    OfficialPlanFabPrpPlnQty: 'official_plan_fab_prp_pln_qty',
    OfficialPlanPoPrSlsQty: 'official_plan_po_pr_sls_qty',
    officalPlanCoQty: 'offical_plan_co_qty',
    officalPlanStockQty: 'offical_plan_stock_qty',
    slsStartDy: 'sls_start_dy',
    publishFlagForFactory: 'publish_flag_for_factory',
    publishDate: 'publish_date',
    allcEndDy: 'allc_end_dy',
    slsEndDy: 'sls_end_dy',
    GWH: 'gwh',
    orderPlanNumber: 'order_plan_number',
    orderTiming: 'order_timing',
    swngPrdMonth: 'swng_prd_month',
    swngPrdWeek: 'swng_prd_week',
    orderPlanQty: 'order_plan_qty',
    orderPlanQtyCoeff: 'order_plan_qty_coeff',
    trnspMthd: 'trnsp_mthd',
    prodPlanType: 'prod_plan_type',
    ph1St: 'ph1_1st',
    wh: 'wh',
    whAct: 'wh_act',
    whAuto: 'wh_auto',
    yarnDlRequested: 'yarn_dl_requested',
    yarnDlAnswered: 'yarn_dl_answered',
    yarnDlAuto: 'yarn_dl_auto',
    yarnProductionDueDateAuto: 'yarn_production_due_date_auto',
    yarnAutoReflectionDate: 'yarn_auto_reflection_date',
    yarnActDy: 'yarn_act_dy',
    yarnActQty: 'yarn_act_qty',
    yarnOrderNumber: 'yarn_order_number',
    yarnOrderStatus: 'yarn_order_status',
    yarnDeliveryDate: 'yarn_delivery_date',
    fbrcDlRequested: 'fbrc_dl_requested',
    fbrcDlAnswered: 'fbrc_dl_answered',
    fbrcDlAuto: 'fbrc_dl_auto',
    fbrcProductionDueDateAuto: 'fbrc_production_due_date_auto',
    fbrcAutoReflectionDate: 'fbrc_auto_reflection_date',
    fbrcActDy: 'fbrc_act_dy',
    fbrcActQty: 'fbrc_act_qty',
    fbrcOrderNumber: 'fbrc_order_number',
    fbrcOrderStatus: 'fbrc_order_status',
    fbrcDeliveryDate: 'fbrc_delivery_date',
    colorDlRequested: 'color_dl_requested',
    colorDlAnswered: 'color_dl_answered',
    colorDlAuto: 'color_dl_auto',
    colorProductionDueDateAuto: 'color_production_due_date_auto',
    colorAutoReflectionDate: 'color_auto_reflection_date',
    colorActDy: 'color_act_dy',
    colorActQty: 'color_act_qty',
    colorOrderNumber: 'color_order_number',
    colorOrderStatus: 'color_order_status',
    colorDeliveryDate: 'color_delivery_date',
    trimDlRequested: 'trim_dl_requested',
    trimDlAnswered: 'trim_dl_answered',
    trimDlAuto: 'trim_dl_auto',
    trimProductionDueDateAuto: 'trim_production_due_date_auto',
    trimAutoReflectionDate: 'trim_auto_reflection_date',
    trimActDy: 'trim_act_dy',
    trimActQty: 'trim_act_qty',
    trimOrderNumber: 'trim_order_number',
    trimOrderStatus: 'trim_order_status',
    trimDeliveryDate: 'trim_delivery_date',
    poDlRequested: 'po_dl_requested',
    poDlAnswered: 'po_dl_answered',
    poDlAuto: 'po_dl_auto',
    poProductionDueDateAuto: 'po_production_due_date_auto',
    poAutoReflectionDate: 'po_auto_reflection_date',
    poActDy: 'po_act_dy',
    poActQty: 'po_act_qty',
    poOrderNumber: 'po_order_number',
    poOrderStatus: 'po_order_status',
    assort1: 'assort1',
    assort2: 'assort2',
    nxAssort: 'nx_assort',
    solid: 'solid',
    orderPlanQtyStop: 'order_plan_qty_stop',
    fixFlag: 'fix_flag',
    alternativeFlag: 'alternative_flag',
    expressLineFlag:'express_line_flag',
    factoryComment: 'factory_comment',
    plannedEXF: 'planned_exf',
    exfEtd: 'exf_etd',
    etdWh: 'etd_wh',
    sweingCountryRegion: 'sweing_country_region',
    rewMaterialOriginal: 'rew_material_original',
    itemDrop: 'item_drop',
    createDate: 'create_date',
    createUserId : 'created_user_id',
    createUserName: 'created_user_name',
    createFunction : 'create_function',
    updateDate: 'update_date',
    updateUserId : 'updated_user_id',
    updateUserName: 'updated_user_name',
    updateFunction : 'updated_user_function',
    countY: 'count_y',
    sample: 'sample',
    exf: 'exf',
    bddl: 'bddl',
    bddlPast: 'bddl_past',
    ltBdExf: 'lt_bd_exf',
    newBddl: 'new_bddl',
    newLtBdExf: 'new_lt_bd_exf',
    ltPoExf: 'lt_po_exf',
    qtyLtBdExf: 'qty_lt_bd_exf',
    qtyLtPoExf: 'qty_lt_po_exf',
    country2Y: 'country2_y',
    phase: 'phase',
    whDate:'wh_date',
    exfDate:'exf_date'
    
}